import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

const PrivacyPolicy = () => {
    // Sayfa yüklendiğinde en üste scroll yap
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-white">
            <NavbarV2 />
            
            {/* Hero Section */}
            <section className="bg-gradient-to-r from-red-50 to-pink-50 py-16 pt-24">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <h1 className="text-4xl font-bold text-gray-800 mb-4">Gizlilik Politikası</h1>
                        <p className="text-lg text-gray-600 mb-6">
                            Verilerinizin güvenliği ve gizliliği bizim için önemlidir
                        </p>
                        <div className="flex items-center justify-center text-sm text-gray-500">
                            <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
                            <span className="mx-2">/</span>
                            <span className="text-red-500">Gizlilik Politikası</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto">
                        <div className="bg-white border rounded-xl p-8 shadow-sm">
                            {/* Last Updated */}
                            <div className="mb-8 p-4 bg-gray-50 rounded-lg">
                                <p className="text-sm text-gray-600">
                                    <strong>Son güncelleme:</strong> 21 Aralık 2024
                                </p>
                            </div>

                            {/* Introduction */}
                            <div className="mb-8">
                                <p className="text-gray-700 mb-4">
                                    Hatim Takip Uygulaması ("Uygulama", "Hizmet") olarak, kişisel verilerinizin gizliliğini koruma 
                                    konusunda titiz davranmaktayız. Bu Gizlilik Politikası, Uygulamamızı kullanırken hangi bilgilerin 
                                    toplandığını, nasıl kullanıldığını ve korunduğunu açıklar.
                                </p>
                            </div>

                            {/* Sections */}
                            <div className="space-y-8">
                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Toplanan Bilgiler</h2>
                                    <div className="text-gray-700">
                                        <h3 className="font-semibold mb-2">Hesap Bilgileri:</h3>
                                        <ul className="list-disc ml-6 mb-4">
                                            <li>E-posta adresi (kimlik doğrulama için)</li>
                                            <li>Şifre (şifreli olarak saklanır)</li>
                                            <li>Kullanıcı adı</li>
                                        </ul>
                                        <h3 className="font-semibold mb-2">Uygulama İçi Veriler:</h3>
                                        <ul className="list-disc ml-6">
                                            <li>Hatim okuma kayıtları</li>
                                            <li>Grup üyelikleri</li>
                                            <li>İstatistik verileri</li>
                                        </ul>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Bilgilerin Kullanımı</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">Toplanan bilgiler şu amaçlarla kullanılır:</p>
                                        <ul className="list-disc ml-6">
                                            <li>Hesap oluşturma ve kimlik doğrulama</li>
                                            <li>Uygulama hizmetlerinin sağlanması</li>
                                            <li>İstatistiklerin hesaplanması</li>
                                            <li>Grup işlevlerinin yönetimi</li>
                                            <li>Teknik destek sağlama</li>
                                        </ul>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Veri Paylaşımı</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">Kişisel verilerinizi üçüncü taraflarla paylaşmıyoruz. İstisnalar:</p>
                                        <ul className="list-disc ml-6">
                                            <li>Yasal zorunluluklar</li>
                                            <li>Kullanıcının açık izni</li>
                                            <li>Anonim istatistiksel veriler</li>
                                        </ul>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Veri Güvenliği</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">Verilerinizin güvenliği için:</p>
                                        <ul className="list-disc ml-6">
                                            <li>Şifreler güvenli algoritmayla şifrelenir</li>
                                            <li>HTTPS kullanarak veri aktarımı</li>
                                            <li>Düzenli güvenlik güncellemeleri</li>
                                            <li>Erişim kontrolleri</li>
                                        </ul>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Kullanıcı Hakları</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">KVKK kapsamında haklarınız:</p>
                                        <ul className="list-disc ml-6">
                                            <li>Verilerinizin işlenip işlenmediğini öğrenme</li>
                                            <li>Verilerinizin düzeltilmesini isteme</li>
                                            <li>Verilerinizin silinmesini talep etme</li>
                                            <li>Hesabınızı tamamen silme</li>
                                        </ul>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Hesap Silme</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">
                                            Hesabınızı ve tüm verilerinizi silmek için kayıtlı e-postanızdan{' '}
                                            <a 
                                                href="mailto:gudersamet@gmail.com?subject=Hesap%20Silme%20Talebi" 
                                                className="text-red-500 hover:underline font-medium"
                                            >
                                                gudersamet@gmail.com
                                            </a>
                                            {' '}adresine "Hesap Silme Talebi" konusu ile e-posta gönderin.
                                        </p>
                                        <p className="mb-4">
                                            Detaylı bilgi için{' '}
                                            <Link to="/account-deletion" className="text-red-500 hover:underline font-medium">
                                                Hesap & Veri Silme
                                            </Link>
                                            {' '}sayfasını ziyaret edin.
                                        </p>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Çerezler</h2>
                                    <div className="text-gray-700">
                                        <p>
                                            Uygulama oturum yönetimi için gerekli çerezler kullanabilir. 
                                            Bu çerezleri tarayıcı ayarlarınızdan yönetebilirsiniz.
                                        </p>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Değişiklikler</h2>
                                    <div className="text-gray-700">
                                        <p>
                                            Bu Gizlilik Politikası gerektiğinde güncellenebilir. 
                                            Güncellemeler bu sayfada yayınlanır ve yayın tarihi itibariyle yürürlüğe girer.
                                        </p>
                                    </div>
                                </section>

                                <section>
                                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. İletişim</h2>
                                    <div className="text-gray-700">
                                        <p className="mb-4">
                                            Gizlilik politikası ile ilgili sorularınız için:
                                        </p>
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="font-medium">E-posta:</p>
                                            <a 
                                                href="mailto:gudersamet@gmail.com" 
                                                className="text-red-500 hover:underline"
                                            >
                                                gudersamet@gmail.com
                                            </a>
                                        </div>
                                    </div>
                                </section>
                            </div>

                            {/* Related Pages */}
                            <div className="mt-12 pt-8 border-t border-gray-200">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                                <div className="grid md:grid-cols-2 gap-4">
                                    <Link 
                                        to="/terms-of-service" 
                                        className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                                    >
                                        <h4 className="font-medium text-gray-800">Kullanım Koşulları</h4>
                                        <p className="text-sm text-gray-600 mt-1">
                                            Uygulama kullanım kuralları ve koşulları
                                        </p>
                                    </Link>
                                    <Link 
                                        to="/account-deletion" 
                                        className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                                    >
                                        <h4 className="font-medium text-gray-800">Hesap & Veri Silme</h4>
                                        <p className="text-sm text-gray-600 mt-1">
                                            Hesap silme sürecinin detayları
                                        </p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterV2 />
        </div>
    );
};

export default PrivacyPolicy;
